/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  LiteLLMInstance,
  LiteLLMInstance$inboundSchema,
} from "./litellminstance.js";

export type ListInstancesResponseBody = {
  instances: Array<LiteLLMInstance>;
};

/** @internal */
export const ListInstancesResponseBody$inboundSchema: z.ZodMiniType<
  ListInstancesResponseBody,
  unknown
> = z.object({
  instances: z.array(LiteLLMInstance$inboundSchema),
});

export function listInstancesResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListInstancesResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListInstancesResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListInstancesResponseBody' from JSON`,
  );
}
